export * from "../../original/js/components/filter";

// soon to be depricated.
import { Filter } from "../../original/js/components/filter";
export default Filter;
